export default __webpack_public_path__ + "static/media/image-homepage-profile@2x.b80aed3f.jpg";